// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"01376d4c","833":"5693a5f3"}[chunkId] + ".chunk.css";
};